declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";

import { Router, ActivatedRoute } from '@angular/router';




declare var require: any;


import { NgbModal, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { routerTransition } from '../../../../../../src/app/ncs/animations/router.animations';
import { NgbAddBill } from './modal/addbill.modal';
import { NgbSearchPatientModal } from '../follow up/counsellingregistry/modal/searchpatient.modal';
import { BillDetailsInfoController, x_BillDetailsRequest, X_BillHeaderController, X_BillItemsController, X_BillReceiptsController, SaveBillItemsInfoRequest, CancelBillRequest } from '../../../models/actor/actor';
import { AppData } from '../../../models/appdata';
import { ActorService } from '../../../services/actor.service';
import * as alertFunctions from '../../../../shared/data/sweet-alerts';
import { ApiResponseModel } from '../../../models/api_response_model';
import { SpinnerService } from '../../../services/spinner.service';
//import { billingpipe } from '../../../pipes/actors/actorIdentity.pipes';
//import { Pipe } from '@angular/core';
//import { Injectable } from '@angular/core';
//import { PipeTransform } from '@angular/core';
import { BillingPipe } from '../../../pipes/actors/actorIdentity.pipes';
import { PrintService } from '../../../../../../src/app/ncs/services/print.service';
import { NgbPaymentModeChangeModal } from './modal/paymentmodechange.modal';
//import { NgbSearchPatientRxModal } from '../follow up/counsellingregistry/modal/searchpatientrx.modal';
import { NgbRxSearchPatientModal } from '../follow up/counsellingregistry/modal/rxsearchpatient.modal';
import { NGXToastrService } from '../../../../shared/services/toastr.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbCombinebillSearchPatientModal } from '../follow up/counsellingregistry/modal/combinebillsearchpatient.modal';
import { NgbChangeDateModal } from './modal/changedate.modal';



@Component({
  selector: 'viewpharmbilling',
  templateUrl: './viewpharmbilling.component.html',
  styleUrls: [
    './viewpharmbilling.component.scss']
  , animations: [routerTransition()]
})

export class ViewPharmBillingComponent implements OnInit {

  @Input() public FromScreen: string = "NONE";
  @Input() public marginTop: number = 18;

  public ApiResData: ApiResponseModel;
  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public SelectedFormattedCode: string;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  public billdetails1: boolean = false;
  public ChargeEntryCode: number;
  public billdetails2: boolean = false;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number;
  public PaidBill: number;
  public searchValue: string;
  public Net: number;
  public Paid: number;
  searchTitle: string;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  TodayDate = new Date();
  SelectedFromDate: NgbDateStruct;
  CurrentBillDetailsInfoController: X_BillHeaderController[];
  CurrentBillDetailsInfoControllernew: X_BillHeaderController[];
  SelectedBillType: X_BillHeaderController[];
  Currentx_BillDetailsRequest: x_BillDetailsRequest;

  LoadForms() {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.pdata = this.CurrentBillDetailsInfoController;
    this.GetBillDetailsInfoController();
  }
  public SelectedReport: string;

  GetBillDetailsInfoController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date();
    this.Currentx_BillDetailsRequest.ToDate = new Date();
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = 'OPBILL';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    this.Currentx_BillDetailsRequest.SearchText = '';

    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType == 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          this.SelectedBillType = this.CurrentBillDetailsInfoController;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
          //this.spinner.hide();
          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentSaveBillItemsInfoRequest: SaveBillItemsInfoRequest;
  CurrentCancelBillRequest: CancelBillRequest;
  constructor(private router: Router,
    public printService: PrintService,
    private modalService: NgbModal,
    private actorservice: ActorService,
    private route: ActivatedRoute,
    private loaderService: SpinnerService,
    private parserFormatter: NgbDateParserFormatter,
    private filter: BillingPipe, private tosterservice: NGXToastrService, private spinner: NgxSpinnerService,


  ) { }

  ngOnInit() {
    this.LoadForms();
    this.SelectedFromDate = { year: this.TodayDate.getFullYear(), month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() };
    // this.pdata = this.CurrentBillDetailsInfoController;
    this.CurrentSaveBillItemsInfoRequest = new SaveBillItemsInfoRequest();
    this.CurrentSaveBillItemsInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentCancelBillRequest = new CancelBillRequest();
    this.CurrentCancelBillRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  }



  ShowList: boolean = true;



  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }
  ChangeDate() {
    const modalRef = this.modalService.open(NgbChangeDateModal,
      {
        centered: true,        
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.BillNo = this.CurrentX_BillHeaderController.BillNo;
    modalRef.componentInstance.CurrentDate = this.CurrentX_BillHeaderController.BillCreatedDate;
    modalRef.componentInstance.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    modalRef.result.then(x => { this.GetX_BillHeaderController() })
  }

  AddNewBill() {

    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })

    modalRef.result.then((val: string) => {


      this.router.navigate(['healins/receipt', { Formattedcodedata: val }]);
      modalRef.componentInstance.FormattedCode = val;
      // this.SelectedFormattedCode = val;

      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      //modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })
    });
  }
  Addpharmacy() {
    const modalRef = this.modalService.open(NgbRxSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Frombills = true;
    modalRef.componentInstance.NotFrombills = false;
    //modalRef.result.then((val: string) => {
    //    if (val != 'Cross click') {
    //        this.router.navigate(['healins/rxreceipt', { FormattedCodedata: val, PatientType: "Registered" }]);
    //    }
    //    });
  }
  Addcommonbill() {
    const modalRef = this.modalService.open(NgbCombinebillSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.Frombills = true;
    modalRef.componentInstance.NotFrombills = false;
    modalRef.componentInstance.TypeofBill = "RX";
  }
  ViewPatientDetails() {
    this.router.navigate(['healins/billview']);
  }
  CancelNewOperation() {

    this.ShowList = true;
  }
  SelectedpatientDetails: X_BillHeaderController;
  Selectedpatient(objCategory: any) {
    var patient: X_BillHeaderController = objCategory;
    if (patient != null) {
      //alert(patient.ChargeEntry);
      this.SelectedpatientDetails = null;
      this.SelectedpatientDetails = patient;

      this.billdetails1 = true;
      this.billdetails2 = true;
      this.LoadBillHeader();
      this.LoadBillItems();
      this.LoadBillReceipts();
    }


  }
  CanCancel(): boolean {
    var billdate = new Date(this.SelectedpatientDetails.BillCreatedDate);//.getDate();
    var today = new Date();//.getDate();
    if (billdate.getDate() == today.getDate() &&
      billdate.getMonth() == today.getMonth() &&
      billdate.getFullYear() == today.getFullYear()
    )
      return true; // go ahead and cancel
    else
      return false;
  }
  Cancel() {
    if (!this.CanCancel()) {
      alertFunctions.AlertParam("Selected Bill Cannot be cancelled" + "...!" + "Only Bills that are generated today can be cancelled");
      return;
    }
    else {
    swal({
      title: 'Bill Cancellation',
      text: "Press Yes Button to Submit Request for Cancellation",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.Cancel2();

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Remove Bill Operation Cancelled :)',
          'error'
        )
      }
    })
  }
 }
  Cancel2() {
    this.spinner.show();
    this.CurrentCancelBillRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    this.CurrentCancelBillRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentCancelBillRequest.ConditionalOperator = 10;
    this.actorservice.CancelBill(this.CurrentCancelBillRequest)
      .subscribe((result) => {

        this.ApiResData = result;
        if (result.Result > 0) {
          this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
          this.stopRefreshing();
          this.spinner.hide();
          this.billdetails1 = false;
          this.billdetails2 = false;
          this.LoadForms();
        }
        else {
          alertFunctions.AlertParam("Invalid Operation :- " + "...!");


          this.stopRefreshing();
          this.spinner.hide();          
        }

      },
        (error) => {


          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.spinner.hide();
            this.stopRefreshing();
          }
        }
      );
  }

  Cancel3() {

      swal({
        title: 'Bill Cancellation',
        text: "Press Yes Button to Submit Request for Cancellation",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#0CC27E',
        cancelButtonColor: '#FF586B',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonClass: 'btn btn-success btn-raised mr-5',
        cancelButtonClass: 'btn btn-danger btn-raised',
        allowOutsideClick: false,
        buttonsStyling: false
      }).then(() => {

        this.Cancel2();

        //this.DeleteActorIdentitiesMedicine(l);
        // alertFunctions.AlertParam('Delete Successfully...!');

      }, function (dismiss) {
        // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
        if (dismiss === 'cancel') {
          swal(
            'Cancelled',
            'Remove Bill Operation Cancelled :)',
            'error'
          )
        }
      })
    
  }

  //Cancel2() {
  //  this.spinner.show();
  //  this.CurrentSaveBillItemsInfoRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry.toString();
  //  this.CurrentSaveBillItemsInfoRequest.ConditionalOperator = 300;
  //  this.actorservice.SaveBillItemsInfo(this.CurrentSaveBillItemsInfoRequest)
  //    .subscribe((result) => {

  //      this.ApiResData = result;
  //      if (result.Result[0].Result > 0) {
  //        this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
  //        this.stopRefreshing();
  //        this.spinner.hide();
  //      }
  //      else {
  //        alertFunctions.AlertParam("Invalid Operation :- " + "...!");


  //        this.stopRefreshing();
  //        this.spinner.hide();
  //      }

  //    },
  //      (error) => {


  //        if (error == "401 - Unauthorized") {
  //          alertFunctions.AlertParamEr(error);
  //          this.spinner.hide();
  //          this.stopRefreshing();



  //        }
  //        else {
  //          alertFunctions.AlertParamEr(error);
  //          this.spinner.hide();
  //          this.stopRefreshing();
  //        }
  //      }
  //    );
  //}

  //Selectedpatient(l: BillDetailsInfoController) {
  //    var chargedentry = l.Header.ChargeEntry;
  //    alert(chargedentry);
  //}
  CurrentX_BillHeaderController: X_BillHeaderController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;

  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          //this.CurrentX_BillHeaderController.Net = Math.round(this.Net);
          //this.CurrentX_BillHeaderController.Paid = Math.round(this.Paid);
          // this.ChargeEntryCode = this.CurrentX_BillHeaderController[0].ChargeEntry;
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  public TotalTax: number;
  CurrentX_BillItemsController: X_BillItemsController[];
  //FollicularScanEndInfo: FollicularScanDetailController;
  //BillHeader: X_BillHeaderController[];
  CurrentX_BillItemsRequest: x_BillDetailsRequest;

  BillData: BillDetailsInfoController;

  LoadBillItems() {
    //alert("ScansData")
    this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillItemsController();
  }

  GetX_BillItemsController() {
    //this.StartRefreshing();

    this.CurrentX_BillItemsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillItemsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillData = this.ApiResData.Result;
          this.CurrentX_BillItemsController = this.BillData.Items;
          this.ChargeEntryCode = this.SelectedpatientDetails.ChargeEntry;
          //this.TotalTax = this.CurrentX_BillItemsController.filter((item) => item.Tax > 0)
          //    .map((item) => +  this.getTax(item))
          //    .reduce((sum, current) => sum + current);
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  //getDisc(item: X_BillItemsController): number {
  //    if (item.Discount > 0)
  //        return (item.ItemTotal * item.Discount) / 100;
  //    return 0;
  //}
  //getTax(item: X_BillItemsController): number {
  //    if (item.Tax > 0)
  //        return (item.ItemTotal - this.getDisc(item)) - ((((item.ItemTotal - this.getDisc(item)) * 100) / (100 + item.Tax)));

  //    return 0;
  //}

  CurrentX_BillReceiptsController: X_BillReceiptsController[];

  CurrentX_BillReceiptsRequest: x_BillDetailsRequest;

  BillDataReceipt: BillDetailsInfoController;

  LoadBillReceipts() {
    //alert("ScansData")
    this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillReceiptsController();
  }

  GetX_BillReceiptsController() {
    //this.StartRefreshing();

    this.CurrentX_BillReceiptsRequest.ChargeEntry = this.SelectedpatientDetails.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillReceiptsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillReceiptsController(this.CurrentX_BillReceiptsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillDataReceipt = this.ApiResData.Result;
          this.CurrentX_BillReceiptsController = this.BillDataReceipt ? this.BillDataReceipt.Receipts : undefined;
          if (this.CurrentX_BillReceiptsController && this.CurrentX_BillReceiptsController.length > 0) {
            this.PatientName = this.CurrentX_BillReceiptsController[0].PatientName;
            this.PayeeName = this.CurrentX_BillReceiptsController[0].PayeeName;
            this.Toatalbill = this.CurrentX_BillReceiptsController[0].AmountPayable;
            this.PaidBill = this.CurrentX_BillReceiptsController[0].AmountPaid;
          }



          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          //this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }


  dataChanged(newobj) {

    this._GetBillDetailsInfoController()
  }
  _GetBillDetailsInfoController() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          this.CurrentBillDetailsInfoControllernew = this.CurrentBillDetailsInfoController.filter(
            function (a) {
              return a.BillType == 'RXBILL';
            });
          this.pdata = this.CurrentBillDetailsInfoControllernew;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  DecrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);

    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() - (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetBillDetailsInfoController();
    //ind++;
  }
  IncrementDate() {
    //this.dateI = new Date();
    //var i = this.dateI.valueOf() + 86400000;
    //this.dateI = new Date(i);
    //this.SelectedFromDate = dateI;
    //var ind: number = 0;
    //this.diff = this.diff - 1;
    //alert(this.diff);
    var monthNo = this.SelectedFromDate.month
    var d: Date = new Date(
      this.SelectedFromDate.year,
      monthNo - 1,
      this.SelectedFromDate.day
    );
    //this.parserFormatter.parse(this.SelectedFromDate).;

    d = new Date((new Date(d)).getTime() + (60 * 60 * 24 * 1000));
    //    d.getFullYear
    //this.SelectedFromDate = { d. , month: this.TodayDate.getMonth() + 1, day: this.TodayDate.getDate() - 1 };

    //  this.SelectedFromDate = this.SelectedFromDate.
    this.SelectedFromDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() };
    this._GetBillDetailsInfoController();
    //ind++;
  }


  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

  //criteriaChange(value: any) {
  //    if (this.filter != null) {
  //        if (value != '[object Event]') {
  //            this.listFilter = value;
  //            //alert(this.listFilter);
  //            this.pdata = this.filter.transform(this.CurrentBillDetailsInfoController,
  //                this.listFilter);
  //        }
  //    }
  //}

  //criteriaChange(value:string) {
  //    //alert(event);
  //    this.Refreshpatients(value);
  //}
  pdata: any[];// = this.data;
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentBillDetailsInfoControllernew;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentBillDetailsInfoControllernew,
          this.listFilter);
      }
    }
  }

  Refreshpatients(st: string) {
    this.Currentx_BillDetailsRequest = new x_BillDetailsRequest();
    this.Currentx_BillDetailsRequest.SearchText = st;
    this.Currentx_BillDetailsRequest.ConditionalOperator = 20;
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.Currentx_BillDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    // this.pdata = this.CurrentBillDetailsInfoController;
    this._GetBillDetailsInfoControllerSearch();
  }
  _GetBillDetailsInfoControllerSearch() {
    this.StartRefreshing();
    //this.spinner.show();
    this.Currentx_BillDetailsRequest.Branch = AppData.Instance().SelectedBranchCode;
    this.Currentx_BillDetailsRequest.FromDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ToDate = new Date(this.parserFormatter.format(this.SelectedFromDate));
    this.Currentx_BillDetailsRequest.ChargeEntry = 0;
    //this.Currentx_BillDetailsRequest.ConditionalOperator = 10;
    this.Currentx_BillDetailsRequest.BillType = '';
    this.Currentx_BillDetailsRequest.FormattedCode = '';
    //alert(this.FormattedCode);
    this.actorservice.GetBillDetailsInfoController(this.Currentx_BillDetailsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.CurrentBillDetailsInfoController = this.ApiResData.Result;
          //this.pdata = this.CurrentBillDetailsInfoController;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          //   this.LoadGuardian();
          //this.LoadMessages();
          //this.LoadOvaryData();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  EditReceipt(l: X_BillReceiptsController) {

    const modalRef = this.modalService.open(NgbPaymentModeChangeModal,
      {
        centered: true

      })
    modalRef.componentInstance.Receiptno = l.FormattedCode;
    modalRef.componentInstance.Billno = l.BillFormattedCode;
    modalRef.componentInstance.CompanyRe = l.CompanyReceiptCode;
    modalRef.componentInstance.PatientName = l.PatientName;
    modalRef.componentInstance.ReceiptDate = l.ReceiptDate;
    modalRef.componentInstance.PaymentInstructions = l.PaymentInstrument;
    modalRef.componentInstance.PatientAccountReceiptDetailCode = l.PatientAccountReceiptDetailCode;
    modalRef.result.then(x => { this.GetX_BillReceiptsController() })

  }
  header() {
    let m = document.querySelector("#header");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  items() {
    let m = document.querySelector("#items");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  Receipts() {
    let m = document.querySelector("#Receipts");
    if (m) {
      m.scrollIntoView({ block: "center", inline: "nearest" });
    }
  }
  billedit() {
    //alert("hello2");
    this.router.navigate(['healins/rxreceiptedit', {
      FormattedCodedata: this.SelectedpatientDetails.PatientFormattedCode,
      ChargeEntryCode: this.ChargeEntryCode,
      BillStatus: this.CurrentX_BillHeaderController.BillStatus
    }]);
  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    this.Refreshpatients(this.searchValue);
  }
  opbill() {
    //alert("hello");
    this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    );
    this.printService.printDocument("opbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  ipadvbill() {
    //alert("hello");
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  opadvbill() {
    //alert("hello");
    this.printService.printDocument("advreceipt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  rxbill() {
    //alert("hello");
    //this.printService.printDocument2(this.SelectedpatientDetails.PatientFormattedCode, 0

    //);
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument4('0', this.SelectedpatientDetails.ChargeEntry

    );
    this.printService.printDocument("pharmacybill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry,
        PatientId: this.SelectedpatientDetails.PatientFormattedCode,
        Owner: this.SelectedpatientDetails.PatientName,
        Gender: this.SelectedpatientDetails.PatientGender,
        Age: this.SelectedpatientDetails.PatientAgeY,
        BillDate: this.SelectedpatientDetails.BillDate,
        BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName,
        ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode,
        GrandTotal: this.SelectedpatientDetails.TotalAmount,
        Discount: this.SelectedpatientDetails.Discount,
        Tax: this.SelectedpatientDetails.Tax,
        Net: Math.round(this.SelectedpatientDetails.Net),
        Due: this.SelectedpatientDetails.Balance,

      },

    );

  }
  A5opbill() {
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5opbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );

  }
  A5ipadvbill() {
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5advrcpt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5opadvbill() {
    //alert("hello");
    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument("A5advrcpt",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry, PatientId: this.SelectedpatientDetails.PatientFormattedCode, Owner: this.SelectedpatientDetails.PatientName, Gender: this.SelectedpatientDetails.PatientGender, Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate, BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName, ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode, GrandTotal: this.SelectedpatientDetails.TotalAmount, Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax, Net: this.SelectedpatientDetails.Net, Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
  A5rxbill() {

    this.printService.printDocument3(this.SelectedpatientDetails.BillNo, 0

    );
    this.printService.printDocument4('0', this.SelectedpatientDetails.ChargeEntry

    );
    this.printService.printDocument("A5rxbill",
      {
        ChargeEntryData: this.SelectedpatientDetails.ChargeEntry,
        PatientId: this.SelectedpatientDetails.PatientFormattedCode,
        Owner: this.SelectedpatientDetails.PatientName,
        Gender: this.SelectedpatientDetails.PatientGender,
        Age: this.SelectedpatientDetails.PatientAgeY, BillDate: this.SelectedpatientDetails.BillDate,
        BillNo: this.SelectedpatientDetails.BillNo,
        Branch: this.SelectedpatientDetails.BranchName,
        ReceiptFormattedCode: this.SelectedpatientDetails.ReceiptFormattedCode,
        GrandTotal: this.SelectedpatientDetails.TotalAmount,
        Discount: this.SelectedpatientDetails.Discount, Tax: this.SelectedpatientDetails.Tax,
        Net: Math.round(this.SelectedpatientDetails.Net), Due: this.SelectedpatientDetails.Balance,

      },

    );
  }
}
